export { default } from './LoansTableImage'
